<div class="mainPart">
  <div class="containerPart">
    <div class="imagePart">
      <img src="assets/img/oops.png" alt="" />
    </div>
    <div class="textPart">
      Il semblerait que vous ayez déjà répondu. Vos réponses sont bien
      enregistrées.
    </div>
  </div>
</div>
